import { createSelector } from '@ngrx/store';
import { orderTypesState } from '../root';

export const getOrderTypes = createSelector(orderTypesState, (orderTypes) => orderTypes);
